<div>
  <jhi-alert></jhi-alert>
  <div class="table-responsive" *ngIf="users$ | async as users">
    <table class="table table-striped">
      <thead>
        <tr jhiSort [predicate]="predicate$ | async" [ascending]="ascending$ | async"
            (predicateChange)="predicate$.next($event)" (ascendingChange)="ascending$.next($event)"
            [callback]="transition.bind(this)">
          <th jhiSortBy="id"><span [translate]="'global.field.id'"></span><span class="fa fa-sort"></span></th>
          <th jhiSortBy="login"><span [translate]="'userManagement.login'"></span> <span class="fa fa-sort"></span></th>
          <th jhiSortBy="email"><span [translate]="'userManagement.email'"></span> <span class="fa fa-sort"></span></th>
          <th></th>
          <th jhiSortBy="langKey"> <span [translate]="'userManagement.langKey'"></span> <span class="fa fa-sort"></span>
          </th>
          <th><span [translate]="'userManagement.lastModifiedBy'"></span></th>
          <th></th>
        </tr>
      </thead>
      <tbody *ngIf="users.length > 0">
        <tr *ngFor="let user of users; trackBy: trackIdentity">
          <td><a [routerLink]="['/user-management', user.login]">{{user.id}}</a></td>
          <td>{{user.login}}</td>
          <td>{{user.email}}</td>
          <td>
            <span *ngIf="!user.activated"
                  class="badge badge-danger hand"
                  [translate]="'userManagement.deactivated'">
            </span>
            <span *ngIf="user.activated"
                  class="badge badge-success hand"
                  [translate]="'userManagement.activated'">
            </span>
          </td>
          <td>{{user.langKey}}</td>

          <td>{{user.lastModifiedBy}}</td>

          <td class="text-right">
            <div class="btn-group flex-btn-group-container">
              <button type="submit"
                      replaceUrl="true"
                      [routerLink]="['/user-management', user.login]"
                      class="btn btn-info btn-sm">
                <span class="fa fa-eye"></span>
                <span class="hidden-md-down" [translate]="'entity.action.view'"></span>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>